import React from 'react';
import { date } from '../../../utils/date';

const StarRating = ({ value }) => {
    const totalStars = 5; // Número total de estrellas
    const stars = Array.from({ length: totalStars }, (_, index) => (
        <i
            key={index}
            style={{ fontSize: 18, letterSpacing: 6 }}
            className={index < value ? 'fa fa-star' : 'fa fa-star-o'}
        ></i>
    ));

    return stars;
};

function ReviewItem({ data }) {
    return (
        <div className="wrapper-order-item">
            <div className="client-name-order d-flex justify-content-between">
                <h4>
                    #{data.purchase.id} - <i>{data.purchase.client.name}</i>
                </h4>
                <span style={{ fontSize: 14 }}>{date(data.createdAt)}</span>
            </div>
            <div>
                <div style={{ fontSize: 16, margin: 0, padding: 0 }}>
                    <span>
                        Atención{' '}
                        <span className="badge badge-success">
                            <StarRating value={data.atencion} />
                        </span>
                    </span>
                </div>
                <div style={{ fontSize: 16, margin: 0, padding: 0 }}>
                    Puntualidad{' '}
                    <span className="badge badge-info">
                        <StarRating value={data.puntualidad} />
                    </span>
                </div>
                <div style={{ fontSize: 16, margin: 0, padding: 0 }}>
                    <p style={{ color: 'black', fontWeight: 'bold' }}>{data.description}</p>
                </div>
            </div>
            {data.purchase.user && (
                <div className="wrapper-bottom-description">
                    <p></p>

                    <p className="text-right">
                        <strong>{data.purchase.user.name.split(' ')[0]}</strong>
                    </p>
                </div>
            )}
        </div>
    );
}

export default ReviewItem;
